
/**
 * 
 * 
 * 
 */
class ColorSelector extends HTMLElement {

    constructor() {
        super();
        this.productId = null;
        this.mode      = null;
        this.innerHTML = `
            <style>
                .dynamic-flex-overflow {
                    display: flex;
                    flex-wrap: wrap;
                }
                
                .dynamic-flex-overflow .controler {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: var(--bg-color-light-grey);
                    height: fit-content;
                    aspect-ratio: 1;
                    align-self: center;
                }
                
                .dynamic-flex-overflow.showing-more .show-more {
                    display: none;
                }
                
                .dynamic-flex-overflow:not(.showing-more) .show-less {
                    display: none;
                }
                
                .dynamic-flex-overflow:not(.is-full) .controler {
                    display: none;
                }
                
                .dynamic-flex-overflow:not(.showing-more) .dynamic-overflow-element.extra-element {
                    display: none;
                }
            </style>
        `
        this.colorElement = document.createElement("content");
        this.appendChild(this.colorElement);
    }

    connectedCallback() {
        this.productId = this.getAttribute("product_id") || "NO-ID";
        this.mode      = this.getAttribute("mode")       || "links";

        this.colorElement.innerHTML = "<p>Loading...</p>"; // Default content
        this.getColorSelectorContent();
    }

    disconnectedCallback() {
        // Clear the interval when the element is removed from the DOM
        clearInterval(this.interval);
    }

    async getColorSelectorContent() {
        if (this.productId === "NO-ID") {
            return this.colorElement.innerHTML = `GIVE ME A group_id ATTRIBUTE`;
        }
        
        let fetchRes = await fetch(`https://bikila.tible.tech/color-selector?product_id=${this.productId}&mode=${this.mode}`);
        let body     = await fetchRes.text();
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(body, 'text/html');
        this.colorElement.innerHTML = ``;
        this.colorElement.appendChild(htmlDoc.querySelector("#parsed-html"));
        this.linkDynamicFlexOverflows();
        if (this.mode === "form") {
            this.linkQuickAddToCart();
        }
    }

    linkQuickAddToCart() {
        let addToCartButton = this.colorElement.querySelector(`#quick-add-to-cart`);
        let getSelectedProduct = () => {
            let currentColor    = this.colorElement.querySelector(`.variant-color-link.current-one`);
            if (!currentColor) {
                return false;
            }
            let productData = currentColor?.dataset?.productData;
            try {
                productData = JSON.parse(productData);
            } catch (error) {
                productData = {};
            }
            return productData;
        }
        let getSelectedVariant = () => {
            let currentColor    = this.colorElement.querySelector(`.variant-color-link.current-one`);
            if (!currentColor) {
                return false;
            }
            let currentVariant  = this.colorElement.querySelector(`#size-form-${currentColor?.dataset?.productId} .variant-size-link.current-one`);
            if (!currentVariant) {
                return false;
            }
            return currentVariant?.dataset?.variantId;
        }
        let checkButtonReadyness = () => {
            addToCartButton.classList.remove("disabled");
            if (!getSelectedVariant()) {
                addToCartButton.classList.add("disabled");
            }
        };
        
        addToCartButton.addEventListener("click", async () => {
            let selectedVariant = getSelectedVariant();
            let selectedProduct = getSelectedProduct();
            if (!selectedVariant) {
                return;
            }
            
            const data = `form_type=product&utf8=%E2%9C%93&id=${selectedVariant}&quantity=1&product-id=${selectedProduct.id}&section-id=template--21876335673641__main`;

            let rawResponse = await fetch("/cart/add.js", {
                headers: {
                  "accept": "text/plain, */*; q=0.01",
                  "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                  "pragma": "no-cache",
                  "sec-fetch-mode": "cors",
                  "sec-fetch-site": "same-origin",
                  "x-requested-with": "XMLHttpRequest"
                },
                referrerPolicy: "strict-origin-when-cross-origin",
                body: data,
                method: "POST",
                mode: "cors",
                credentials: "include"
            });
            

            let offset = 25;
            const nav = theme.Nav();
            if(nav.bar.getPositionSetting() !== "inline") {
                offset = nav.bar.height();
            }
            
            window.showThemeModal([
                '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">',
                `<div class="inner" style="top:${offset}px">`,
                '<a href="#" data-modal-close class="modal-close">&times;</a>',
                '<h4 id="added-to-cart-title">' + '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>' + ' Añadido al carrito' + '</h4>',
                '<div class="cart-product">',
                `<div class="cart-product__image"><img src="${selectedProduct.image.src}" alt="¿?"/></div>`,
                '<div class="cart-product__content">' +
                '<p class="cart-product__content__title">', selectedProduct.title, '</p>' +
                '</div>',
                '</div>',
                `<p class="links">`,
                  '<a href="/cart" class="button">Ver carrito</a>',
                '</p>',
                '</div>',
                '</div>'
              ].join(''), "added-to-cart", null);
            
        });

        this.colorElement.addEventListener("click", checkButtonReadyness);
        checkButtonReadyness();
    }

    /**
     * 
     * Vincula en los elementos que no estén vinculados aún los eventos para que se muestre dinámicamente los bloques
     * 
     * @returns {void} 
     */
    linkDynamicFlexOverflows() {

        let _dynamicDiv = this.colorElement.querySelector(".dynamic-flex-overflow");

        if (_dynamicDiv.isLinked) return;
        _dynamicDiv.isLinked = true;

        let renderedLinks = _dynamicDiv.querySelectorAll(".dynamic-overflow-element");
        if (renderedLinks.length <= 0) {
            _dynamicDiv.remove();
            return;
        }
        
        let showMoreButton = this.createNode("div", ["controler", "show-more"], {onclick: () => _dynamicDiv.classList.add(`showing-more`), innerHTML: `<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>`});
        _dynamicDiv.appendChild(showMoreButton);
        let showLessButton = this.createNode("div", ["controler", "show-less"], {onclick: () => _dynamicDiv.classList.remove(`showing-more`), innerHTML: `<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>`});
        _dynamicDiv.appendChild(showLessButton);

        let recheckSize = () => {
            let availableWidth = _dynamicDiv.clientWidth;
            let linkWidth = undefined;
        
            renderedLinks.forEach(renderedLink => {
                if (linkWidth === undefined) {
                    let bounding = renderedLink.getBoundingClientRect();
                    let computedStyles = window.getComputedStyle(renderedLink);
                    let computedStylesParent = window.getComputedStyle(_dynamicDiv);
                    let flexGapParent = computedStylesParent.gap;
                    linkWidth = bounding.width + parseInt(computedStyles.marginLeft) + parseInt(computedStyles.marginRight);
                }
                renderedLink.classList.remove("extra-element");
            });
        
            _dynamicDiv.style.overflowX      = "auto";
            _dynamicDiv.style.display        = "flex";
            _dynamicDiv.style.flexWrap       = "nowrap";
            _dynamicDiv.style.scrollbarWidth = "none";
        
            renderedLinks.forEach(renderedLink => {
                renderedLink.classList.remove("extra-element");
            });
        }
        
        recheckSize();
        window.addEventListener("resize", recheckSize);
        
    }

    /**
     * 
     * Función de ayuda para simplificar la creación de Nodos
     * 
     * @param {String} type Tipo de nodo a crear
     * @param {String[Array]} classArray Clases que queremos añadir a nuestro elemento
     * @param {Object} options Opciones extra a añadir a nuestro elemento
     * @returns 
     */
    createNode(type, classArray = [], options = {}) {
        let node = document.createElement(type);
        // Asignamos todas las características de nuestro objeto al nodo creado 
        for (let [optionKey, optionValue] of Object.entries(options)) {
            node[optionKey] = optionValue;
        }
        
        // Asignamos las clases controlando errores
        classArray.map(singleClass => {
            try {
            node.classList.add(singleClass); 
            } catch (error) {
                console.warn(node, `Could not add the class ${singleClass} to the classList node`);
            }
        });      
        return node;
    }

}

customElements.define('color-selector', ColorSelector);
